import PropTypes from 'prop-types';
import React from 'react';
import { get, isEmpty } from 'lodash';
import { Icon } from '@unite-us/ui';
var WebsiteUrl = function WebsiteUrl(_ref) {
  var provider = _ref.provider,
    noLink = _ref.noLink,
    iconStyle = _ref.iconStyle;
  if (isEmpty(get(provider, 'website_url'))) {
    return null;
  }
  if (noLink) {
    return /*#__PURE__*/React.createElement("div", {
      className: "website-url"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "IconGlobe",
      style: iconStyle
    }), /*#__PURE__*/React.createElement("span", null, provider.website_url));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "website-url"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconGlobe"
  }), /*#__PURE__*/React.createElement("a", {
    id: "".concat(provider.id, "-website-link"),
    href: provider.website_url,
    title: "Organization Website",
    target: "_blank"
  }, provider.website_url));
};
WebsiteUrl.propTypes = {
  provider: PropTypes.object,
  iconStyle: PropTypes.object,
  noLink: PropTypes.bool
};
WebsiteUrl.defaultProps = {
  noLink: false,
  iconStyle: {
    svg: {
      height: '12px',
      width: '12px'
    }
  },
  provider: {}
};
export default WebsiteUrl;